import React, { Component } from "react";
import styles from "./filterAndSearchTools.module.scss";
import { withLogosticFilter } from "../../../shared/containers/containerLogosticFilter";
import { withLogisticGroups } from "../../../shared/containers/containerLogisticGroups";
import { withLogisticControlPoints } from "../../../shared/containers/containerLogisticControlPoints";
import { MenuItem, Select } from "@mui/material";

class FilterLogisticGroupsTools extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedGroups: [],
    };
  }

  componentDidMount() {
    const { logisticGroupsFilter } = this.props;

    this.setState({ selectedGroups: logisticGroupsFilter });
  }

  onSelectGroup(id) {
    const { logisticGroups, onSetLogisticGroups, searchTerm, onFilter } = this.props;
    const { selectedGroups } = this.state;

    const group = logisticGroups.filter((x) => {
      return x.id === id;
    })[0];

    if (group !== undefined) {
      const _selectedGroups = selectedGroups.concat([group]);

      this.setState({ selectedGroups: _selectedGroups });
      onSetLogisticGroups(_selectedGroups);
      onFilter({
        searchTerm,
        logisticGroups: _selectedGroups.map((x) => {
          return x.id;
        }),
      });
    }
  }

  onUnSelectGroup(id) {
    const { onSetLogisticGroups, searchTerm, onFilter } = this.props;
    const { selectedGroups } = this.state;

    const _selectedGroups = selectedGroups.filter((x) => {
      return x.id !== id;
    });

    this.setState({ selectedGroups: _selectedGroups });
    onSetLogisticGroups(_selectedGroups);
    onFilter({
      searchTerm,
      logisticGroups: _selectedGroups.map((x) => {
        return x.id;
      }),
    });
  }

  render() {
    const { logisticGroups } = this.props;
    const { selectedGroups } = this.state;

    if (logisticGroups.length === 0) return null;

    return (
      <div className={styles.filterGroupContainer}>
        <div className={styles.filterGroupInputContainer}>
          <div>Фильтр по группам</div>
          <Select
            style={{ minWidth: "200px", height: "36px", color: "#888888" }}
            onChange={(e) => {
              this.onSelectGroup(e.target.value);
            }}
            value={""}
          >
            {logisticGroups
              .filter((x) => {
                const isSelect = selectedGroups.some((s) => {
                  return s.id === x.id;
                });

                return !isSelect;
              })
              .sort((a, b) => (a.title > b.title ? 1 : b.title > a.title ? -1 : 0))
              .map((x) => {
                return (
                  <MenuItem key={x.id} value={x.id} className={styles.MuiButtonBase_resolve}>
                    {x.title}
                  </MenuItem>
                );
              })}
          </Select>
        </div>
        <div className={styles.filterGroupItemsContainer}>
          {selectedGroups
            .sort((a, b) => (a.title.length > b.title.length ? 1 : -1))
            .map((x) => {
              return (
                <div key={x.id} className={styles.selectedGroupContainer}>
                  <div>{x.title}</div>
                  <div className={styles.closeSelectGroup}>
                    <span
                      className="icon-x"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.onUnSelectGroup(x.id);
                      }}
                    ></span>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

export default withLogisticControlPoints(withLogisticGroups(withLogosticFilter(React.memo(FilterLogisticGroupsTools))));
